module.exports = __webpack_public_path__ + "static/media/C-3PO.ae5458db.jpg";